import { Card, Grid, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router";
import DataService from "../../../../Service";
import HomeHeaderMenu from "../../../Home/HomeHeaderMenu";
import HeaderMenu from "../../../../Components/HeaderMenu";
import User from "../../../../Images/User.png";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useParams } from "react-router-dom";

// fuction for checking type of a property
const typeOf = (value: any) => {
  // @ts-ignore
  return {}.toString
    .call(value)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
};

const CoachDetail = (props: any) => {
  const { noHeader, propsState } = props;
  console.log("noHeader", noHeader, propsState);
  const location: any = useLocation();
  // let { coach_id,type,role } = useParams();
console.log('location :>> ', location);
  const classes = useStyles();
  const [profileImage, setProfileImage] = useState("");
  const [profileName, setProfileName] = useState("");


  const [locationValue, setLocationValue] = useState(
    propsState ? propsState : location.state
  );

  const modifyFields = [
    "Representative engagements",
    "Professional development and supervision",
    "Representative facilitation programmes",
    "Clients mentored",
    "Representative clients",
    "Client specific areas of expertise",
    "Representative coaching engagements",
    "Representative mentoring engagements",
    "Levels of clients mentored",
    "Facilitation clients",
    "Qualifications",
    // "Education_and_qualifications",
    "representative_clients",
    "Client mentoring testimonials",
  ];

  const internalModifyFields = [
    "Representative engagements",
    "Professional development and supervision",
    "Representative facilitation programmes",
    "Clients mentored",
    "Representative clients",
    "Representatitive clients",
    "Representative coaching engagements",
    "Representative mentoring engagements",
    "Levels of clients mentored",
    "Facilitation clients",
    "Qualifications",
    "Education and qualifications",
    "representative_clients",
    "Client testimonials",
  ];
  // console.log(
  //   "location.state.coachType",
  //   location.state,
  //   location.state.coachType
  // );



  const [profileData, setProfileData] = useState([]);

  // const renderData: any = [
  //   "Coaching overview",
  //   "Coaching approach",
  //   "Background/ Career history",
  //   "Coaching areas of expertise",
  //   "Client specific areas of expertise",
  //   "Representative coaching engagements",
  //   "Level of clients coached",
  //   "Representative clients",
  //   "Qualification",
  //   "Education and qualifications",
  //   "Professional development and supervision",
  //   "Professional affiliations",
  //   "Psychometric and diagnostic tools",
  //   "Languages",
  //   "Personal interests",
  //   "Client testimonials",
  //   "Client mentoring testimonials",

  // ]
  // const fullData = [{ "heading": "", "value": "", "data": "" }];
  // const newData = renderData.map((e: any) => ({ "heading": e, "value": "", "data": "" }))
  // console.log("newData", newData)
  // const [realData, setRealData] = useState(newData);
  // let copiedUrl1: any = localStorage.getItem("coach_detail")
  // ? localStorage.getItem("coach_detail")
  // : "";
  // var queryparams = copiedUrl1.split('?')[0];
  // var queryparams1 = copiedUrl1.split('?')[1];
  // var queryparams2 = copiedUrl1.split('?')[2];
  // localStorage.setItem("queryparams",queryparams)
 
  // const querystring = require('querystring');
  // const val = querystring.parse(queryparams1)
  // let { external_coach_id } = useParams<{external_coach_id: string}>();
  // const queryStringg = window.location.search;
  // var queryparamss = queryStringg.split('?')[0];
  // let params = useParams<{params: string}>();

  // console.log('queryparams2 :>> ', external_coach_id,queryStringg,queryparamss);

  let searchParams = new URLSearchParams(location.search);
  const tester = searchParams.get("external_coach_id");
//  console.log('object :>> ',  tester?.split('?')[0]);
 let external_coach_id = tester?.split('?')[0];
   // let { external_coach_id } = useParams<{external_coach_id: string}>();

  const moduleSetup = useCallback(() => {
    let url;
    let params;
    console.log(locationValue?.coachType,"coach type")
    if(external_coach_id !== null){
      url = "coach_panels/view_external_coach_profile";
      params = {
        external_coach_id: external_coach_id,
        role: locationValue?.selectedRole,
      };
    }
    if (locationValue?.coachType === "external") {
      url = "coach_panels/view_external_coach_profile";
      params = {
        external_coach_id: locationValue?.id,
        role: locationValue?.selectedRole,
      };
    }
     if(locationValue?.coachType === "combined"){
      console.log(locationValue,"location value coach type")
      if(locationValue?.selectedType==="partner"){
        url = "coach_panels/view_external_coach_profile";
        params = {
          external_coach_id: locationValue?.id,
          role: locationValue?.selectedRole,
        };
      }
      if(locationValue?.selectedType==="employee"){
        url = "coach_panels/view_internal_coach_profile";
        params = {
          internal_coach_id: locationValue?.id,
          role: locationValue?.selectedRole,
        };
      }
    }

    if(locationValue?.coachType === "internal") {
      url = "coach_panels/view_internal_coach_profile";
      params = {
        internal_coach_id: locationValue?.id,
        role: locationValue?.selectedRole,
      };
    }

    DataService.getDirectData(url, params).then((res) => {
      let data: any = [];
      if (locationValue?.coachType === "external") {
        res.photo?.url != null && setProfileImage(res.photo?.url);
        setProfileName(res?.coach_name);
        data = res.coach_profile_data;
      } else {
        res.internal_coach_profile?.picture?.url != null &&
          setProfileImage(res.internal_coach_profile.picture?.url);
        setProfileName(res?.coach_name);
        data = res.coach_profile_data;
      }
      if (locationValue?.coachType === "external") {
        data.map((option: any) => {
          option.data = [];
          console.log('option :>> ', option.value);
          // if(option.value === null){
          if (modifyFields.includes(option.heading)) {
            option.data = option?.value
              ?
               option?.value
                .trim()
                .split("\n")
                ?.filter((item: any) => item)
              :  option?.value === null ? "" :[];
          } else {
            typeof option?.value == "string"
              ? (option.data = option?.value)
              : option?.value?.length &&
              option?.value.map((options: any) => {
                option.data.push(options);
              });
          }
        // }?
        });
        setProfileData(data);
      } else {
        data?.length &&
          data
            .filter((val: any) => Boolean(val?.value))
            .map((option: any) => {
              option.data = [];
              if (internalModifyFields.includes(option.heading)) {
                option.data = option.value
                  ? option.value
                    .trim()
                    .split("\n")
                    ?.filter((item: any) => item)
                  : [];
              } else {
                typeof option.value == "string" ||
                  typeof option.value == "number"
                  ? (option.data = option.value)
                  : option.value.length &&
                  option.value.map((options: any) => {
                    option.data.push(options);
                  });
              }
            });
        profileData.length = 0;
        setProfileData(data);
      }

    });
  }, [locationValue]);
  useEffect(() => {
    moduleSetup();
  }, [locationValue]);
  
  // console.log("realData", realData)
  let role = sessionStorage.getItem("role");
  //

  const dynamicGridStyle = (length: number) => {
    if (length % 5 === 0) {
      return 5
    }
    else {
      if (length <= 5) {
        return 5
      }
      if (length > 5 && length <= 10) {
        return Math.round(length / 2)
      }
      if (length > 10) {
        return 5;
      }

    }
  }

  return (
    <>
      {noHeader ? null : role === "partner" || role === "employee" ? (
        <HomeHeaderMenu />
      ) : (
        <HeaderMenu />
      )}
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="center"
        className={classes.headerBg}
        style={{ marginBottom: `${noHeader ? "164px" : "100px"}` }}
      >
        <Grid item xs={12}>
         {} <ArrowBackIcon
            className={classes.backButton}
            
            onClick={() => {
              if (noHeader) {
                props.onClose();
              } else {
                props.history.goBack();
              }
            }}
          />
        </Grid>
        <Grid item xs={10} className={classes.headerinfo}>
          <Grid container direction="row" alignItems="center">
            <Grid item xs={1} style={{ position: "relative" }}>
              <div>
                <img
                  src={profileImage || User}
                  alt={profileName}
                  className={classes.userImg}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={9}
              style={{
                alignSelf: "flex-start",
                marginTop: "35px",
                marginLeft: "80px",
              }}
            >
              <Typography variant="h1" style={{ margin: 0, fontWeight: "bold", }}>{profileName}</Typography>
              <Typography variant="h2" className={classes.userTitle}>
                {locationValue?.selectedRole}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {console.log("profileData", profileData)}
      <Grid container direction="row" alignItems="center" justify="center">
        <Grid item xs={10}>
          {console.log(profileData
            .filter((item: any) => item.heading !== "Role")
            .filter((item: any) => item.heading !== "Country")
            .filter((item: any) => item.data && item.data.length))}
          {profileData.length > 0 &&
            profileData
              .filter((item: any) => item.heading !== "Role")
              .filter((item: any) => item.heading !== "Country")
              .filter((item: any) => item.data && item.data.length)
              .map((desData: any) => {
                return (
                  <Grid container direction="row" justify="center" style={{ marginBottom: "16px " }}>
                    <Grid item xs={3} className={classes.coachHeaderContent}>
                      <Typography variant="h2" className={classes.coachTitle}>
                        {desData?.heading === "Qualifications" ? "Education and qualifications" : desData?.heading}
                      </Typography>
                    </Grid>
                    <Grid item xs={9} className={classes.coachValueContent}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        justify="center"
                      >
                        <Grid item xs={12}>
                          {typeof desData?.data === "string" ? (
                            <Typography
                              variant="h2"
                              paragraph
                              className={classes.itemValueString}
                            >
                              {desData.data || "-"}
                            </Typography>
                          ) : (
                            <ul
                              className={
                                [
                                  // "Representative mentoring engagements",
                                  "Types of clients",
                                  // "Languages",
                                  // "Representative clients",
                                  // "Representatitive clients",
                                  // "Levels of clients mentored",
                                  "Client mentoring testimonials",
                                  // "Psychometric and diagnostic tools",
                                  // "Psychometric and diagnostics tools",
                                  "Representative engagements",
    "Professional development and supervision",
    "Professional affiliations",
    "Representative facilitation programmes",
    "Clients mentored",
    "Representative clients",
    "Representatitive clients",
    "Representative coaching engagements",
    "Representative mentoring engagements",
    "Levels of clients mentored",
    "Facilitation clients",
    "Qualifications",
    "Education and qualifications",
    "Psychometric and diagnostics tools",
    "representative_clients",
    "Client testimonials",
    "Languages",
                                ].includes(desData?.heading) &&
                                  desData.data.length > 5
                                  ? classes.itemListingMultiple
                                  : classes.itemListing
                              }
                              style={{
                                gridTemplateRows: `repeat(${dynamicGridStyle(desData.data.length)}, min-content)`,
                                gridTemplateColumns: "25% 25% 25% 25%",
                              }}
                            >
                              {desData.data.length &&
                                desData?.data
                                  .filter(
                                    (val: string | number) =>
                                      Boolean(val) && val !== "\r"
                                  )
                                  .map((res: any) => (
                                    <li>
                                      <Typography
                                        variant="h2"
                                        paragraph
                                        className={classes.itemValueString}
                                      >
                                        {res || "-"}
                                      </Typography>
                                    </li>
                                  ))}
                            </ul>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* </>
            } */}
                  </Grid>
                );
              })}
        </Grid>
      </Grid>
    </>
  );
};
export default CoachDetail;

const useStyles = makeStyles((theme) => ({
  headerBg: {
    backgroundColor: "#EBEAEA",
    height: 180,
    position: "sticky",
    top: "64px",
    // left: "0px",
  },
  userTitle: {
    color: "#232323",
    textTransform: "inherit",

  },
  headerinfo: {
    background: "linear-gradient(180deg, #ebeaea 68.5%, #ffffff 51%)",
  },
  userImg: {
    borderRadius: "50%",
    width: 172,
    height: 172,
  },
  coachTitle: {
    color: theme.palette.secondary.main,
    fontWeight: "bold",
    // marginLef: 30,
    // marginTop: 30,
    margin:0
  },
  coachHeaderContent: {
  },
  coachValueContent: {

  },
  itemListing: {
    marginTop: "0px",
    paddingLeft: "15px",
    marginBottom: "0px",
    "& li": {
      paddingBottom: "5px",
    },
  },
  itemListingMultiple: {
    margin: 0,
    paddingLeft: "5px",
    display: "grid",

    gridAutoFlow: "column",
    "& li": {
      margin: "0 10px",
    },
  },
  cardBorder: {
    padding: 10,
    marginTop: 25,
    border: "1px solid #077F83",
  },
  clientName: {
    color: "#232323",
    float: "right",
    fontWeight: "bold",
    marginRight: 60,
    marginBottom: 20,
  },
  backButton: {
    margin: "30px 0px 0px 40px",
    cursor: "pointer",
  },
  itemValueString: {
    color: "#000000",
    textAlign: "left",
    fontFamily: 'inherit',
    marginBottom: "5px"
  },
}));
